export function resolveDeepLinkDrawer(requestedItemId: string | null, lastOpenedId: string | null) {
  if (!requestedItemId) return { shouldOpen: false, lastOpenedId: null }
  if (requestedItemId === lastOpenedId) return { shouldOpen: false, lastOpenedId }
  return { shouldOpen: true, lastOpenedId: requestedItemId }
}
